<template>
  <div class="animated fadeIn">
    <div v-if="iscreate">
      <createDeliverysetup @created="iscreate = false"></createDeliverysetup>
    </div>
    <div v-if="isedit">
      <editDeliverysetup
        @edit="isedit = false"
        :details="deliveryData"
      ></editDeliverysetup>
    </div>
    <div v-if="isview">
      <viewDeliverysetup
        @view="isview = false"
        :details="deliveryData"
      ></viewDeliverysetup>
    </div>
    <b-card
      class="card-wrap"
      header="Delivery Setup"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-if="!iscreate && !isedit && !isview"
    >
      <b-row>
        <b-col md="12" v-if="!iscreate && !isedit && !isview">
          <eb-button
            class="btn float-right mr-2"
            classic="mr-1 btn-primary"
            text="Create Delivery Charge"
            icon="fa fa-plus-circle mr-1"
            iconSide="left"
            @click="iscreate = true"
          ></eb-button>
        </b-col>
      </b-row>
      <div class="mt-2" v-if="!iscreate && !isedit && !isview">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="deliverys"
          thead-class="header"
          class="mt-3 tableRadius"
          :fields="Columns"
          show-empty
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="primary"
              @click="ViewDeliverysetup(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="primary"
              @click="EditDeliverysetup(data.item)"
            >
              <i class="fa fa-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 butto-circle"
              variant="danger"
              @click="deletedelivery(data)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button>
          </template>
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template slot="city" slot-scope="data">
            <p>
              {{ data.item.city == "*" ? "All cities" : data.item.city }}
            </p>
          </template>
        </b-table>
      </div>
      <div
        style="float: right"
        v-if="!iscreate && !isedit && !isview && deliverys.length > 0"
      >
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="deliverys.length"
          aria-controls="my-table"
          prev-text="Prev"
          pills
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import CreateDeliverysetup from "@/components/MasterSetup/deliverysetup/CreateDeliverysetup";
import EditDeliverysetup from "@/components/MasterSetup/deliverysetup/EditDeliverysetup";
import ViewDeliverysetup from "@/components/MasterSetup/deliverysetup/ViewDeliverysetup";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import currentUserData from "@/mixins/currentUser";
export default {
  name: "DeliverySetup",
  mixins: [currentUserData],
  components: {
    ebButton,
    loader,
    CreateDeliverysetup,
    EditDeliverysetup,
    ViewDeliverysetup,
  },
  data() {
    return {
      deliveryData: [],
      perPage: 10,
      iscreate: false,
      sortBy: "createdAt",
      sortDesc: true,
      isedit: false,
      isview: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      subscriptionData: {},
      Columns: [
        {
          key: "Id",
          sortable: true,
        },
        {
          key: "city",
        },
        {
          key: "areaCode",
        },
        {
          key: "StartDate",
        },
        {
          key: "EndDate",
        },
        {
          key: "dwf",
        },
        {
          key: "rank",
        },
        {
          key: "transportMode",
        },
        {
          key: "action",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("coupon/couponCodeList");
  },
  computed: {
    ...mapGetters({
      couponcode: "coupon/couponCodeList",
    }),

    deliverys() {
      let data = this.$store.getters["delivery/GetDeliveryList"];
      let deliveryList = [];

      if (Array.isArray(data) && data.length > 0) {
        data.map((e) => {
          let arrayObj = {
            StartDate: moment(e.startDate).format("DD/MM/yyyy"),
            EndDate: moment(e.endDate).format("DD/MM/yyyy"),
            city: e.city,
            category_id: e.category,
            Id: e._id,
            rank: e.rank,
            status: e.status,
            tenant: e.tenant,
            areaCode: e.areaCode,
            transportMode: e.transportMode,
            dwf: e.dwf,
            distance: e.distance,
            restData: e,
            ...e,
          };
          if (e.deliveryOwner) {
            if (e.deliveryOwner._id == this.$currentUserData._id) {
              deliveryList.push(arrayObj);
            }
          }
        });

        return deliveryList.sort(
          (a, b) =>
            new Date(b.restData.updatedAt) - new Date(a.restData.updatedAt)
        );
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    EditDeliverysetup(data) {
      this.deliveryData = data;
      this.isedit = true;
    },
    ViewDeliverysetup(data) {
      this.isview = true;
      this.deliveryData = data;
    },

    deletedelivery(data) {
      var itemid = data.item._id;
      this.$swal({
        title: "Delete this Delivery setup details?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("delivery/deleteDeliverySetup", itemid)
            .then((result) => {
              this.$toasted.success(
                "Delivery setup details Deleted Successfully"
              );
              this.$store
                .dispatch("delivery/fetchdeliverysList")
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
      this.$store.dispatch("delivery/fetchdeliverysList");
    },
  },
  async mounted() {
    await this.$store.dispatch("delivery/fetchdeliverysList").then((data) => {
      if (data.message) {
        this.$toasted.error(data.message);
      } else {
      }
    });
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
